// extracted by mini-css-extract-plugin
export default {"balance":"Balance_balance__EBDUL","fractionalPart":"Balance_fractionalPart__2nSjw","icon":"Balance_icon__Dnc4q"};